export default __webpack_public_path__ + "static/media/visual_06.5a7f381f.png";